import axios from "../../lib/axiosInstance";

export function createWorkOrder(payload) {
  return axios.post("workOrders", payload).then((res) => res.data);
}
// Client reviews a customer-raised ticket (PENDING_APPROVAL) and publishes it to the marketplace.
// While a counter offer to the customer is unanswered the server refuses with a 409
// (code COUNTER_OFFER_PENDING) unless publishWithCustomerRates says the client has
// seen the warning and wants to publish at the customer's current rates anyway.
export function approveAndPublishWorkOrder({ workOrderId, publishWithCustomerRates = false }) {
  return axios
    .post(`workOrders/${workOrderId}/approvePublish`, { publishWithCustomerRates })
    .then((res) => res.data);
}
export function uploadWorkOrderPurchaseOrder({ workOrderId, formData }) {
  return axios.post(`workOrders/${workOrderId}/purchaseOrder`, formData).then((res) => res.data);
}
export function deleteWorkOrderPurchaseOrder(workOrderId, purchaseOrderId) {
  return axios
    .delete(`workOrders/${workOrderId}/purchaseOrder/${purchaseOrderId}`)
    .then((res) => res.data);
}
export function uploadWorkOrderExpenseAttachments({ workOrderId, formData }) {
  return axios
    .post(`workOrders/${workOrderId}/expenseAttachments`, formData)
    .then((res) => res.data);
}
export const fetchUserWorkOrders = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.role) queryParams.append("role", payload.role);
  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);

  if (Array.isArray(payload.status)) {
    payload.status.forEach((s) => s && queryParams.append("status", s));
  } else if (payload.status) {
    queryParams.append("status", payload.status);
  }
  if (payload.search?.trim()) queryParams.append("search", payload.search.trim());
  if (Array.isArray(payload.sortBy)) {
    queryParams.append("sortBy", payload.sortBy.join(","));
  } else if (payload.sortBy) {
    queryParams.append("sortBy", payload.sortBy);
  }
  if (payload.sortOrder) queryParams.append("sortOrder", payload.sortOrder);

  if (payload.categoryId) queryParams.append("categoryId", payload.categoryId);
  if (payload.vendorId) queryParams.append("vendorId", payload.vendorId);
  if (Array.isArray(payload.subCategoryIds) && payload.subCategoryIds.length > 0) {
    queryParams.append("subCategoryIds", payload.subCategoryIds.join(","));
  } else if (typeof payload.subCategoryIds === "string") {
    queryParams.append("subCategoryIds", payload.subCategoryIds);
  }
  if (Array.isArray(payload.clientIds) && payload.clientIds.length > 0) {
    queryParams.append("clientIds", payload.clientIds.join(","));
  } else if (typeof payload.clientIds === "string") {
    queryParams.append("clientIds", payload.clientIds);
  }
  if (Array.isArray(payload.teamIds) && payload.teamIds.length > 0) {
    queryParams.append("teamIds", payload.teamIds.join(","));
  } else if (typeof payload.teamIds === "string") {
    queryParams.append("teamIds", payload.teamIds);
  }

  if (payload.minRate) queryParams.append("minRate", payload.minRate);
  if (payload.maxRate) queryParams.append("maxRate", payload.maxRate);

  if (payload.minRequests || payload.minRequests === 0)
    queryParams.append("minRequests", payload.minRequests);
  if (payload.maxRequests || payload.maxRequests === 0)
    queryParams.append("maxRequests", payload.maxRequests);

  if (payload.paymentType) queryParams.append("paymentType", payload.paymentType);

  if (payload.startDate) queryParams.append("startDate", payload.startDate);
  if (payload.endDate) queryParams.append("endDate", payload.endDate);
  if (payload.createStartDate) queryParams.append("createStartDate", payload.createStartDate);
  if (payload.createEndDate) queryParams.append("createEndDate", payload.createEndDate);
  if (payload.country) queryParams.append("country", payload.country);
  if (payload.city) queryParams.append("city", payload.city);
  if (payload.providerId) queryParams.append("providerId", payload.providerId);
  if (payload.teamId) queryParams.append("teamId", payload.teamId);
  if (payload.clientId) queryParams.append("clientId", payload.clientId);
  if (payload.projectId) queryParams.append("projectId", payload.projectId);
  if (payload.currency) queryParams.append("currency", payload.currency);
  if (payload.engineerCurrency) queryParams.append("engineerCurrency", payload.engineerCurrency);
  if (payload.createdById) queryParams.append("createdById", payload.createdById);
  if (payload.id) queryParams.append("id", payload.id);
  if (payload.canceledBy) queryParams.append("canceledBy", payload.canceledBy);
  if (payload.cancellationReason) queryParams.append("cancellationReason", payload.cancellationReason);
  // The columns the list is showing; the backend returns data for these alone.
  if (payload.columns?.length)
    queryParams.append("columns", [].concat(payload.columns).join(","));
  const response = await axios.get(`workOrders?${queryParams.toString()}`);
  return response.data;
};
export const fetchCustomerWorkOrders = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.role) queryParams.append("role", payload.role);
  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);

  if (Array.isArray(payload.status)) {
    payload.status.forEach((s) => s && queryParams.append("status", s));
  } else if (payload.status) {
    queryParams.append("status", payload.status);
  }
  if (payload.search?.trim()) queryParams.append("search", payload.search.trim());
  if (Array.isArray(payload.sortBy)) {
    queryParams.append("sortBy", payload.sortBy.join(","));
  } else if (payload.sortBy) {
    queryParams.append("sortBy", payload.sortBy);
  }
  if (payload.sortOrder) queryParams.append("sortOrder", payload.sortOrder);

  if (payload.categoryId) queryParams.append("categoryId", payload.categoryId);
  if (payload.vendorId) queryParams.append("vendorId", payload.vendorId);
  if (Array.isArray(payload.subCategoryIds) && payload.subCategoryIds.length > 0) {
    queryParams.append("subCategoryIds", payload.subCategoryIds.join(","));
  } else if (typeof payload.subCategoryIds === "string") {
    queryParams.append("subCategoryIds", payload.subCategoryIds);
  }
  if (Array.isArray(payload.clientIds) && payload.clientIds.length > 0) {
    queryParams.append("clientIds", payload.clientIds.join(","));
  } else if (typeof payload.clientIds === "string") {
    queryParams.append("clientIds", payload.clientIds);
  }
  if (Array.isArray(payload.teamIds) && payload.teamIds.length > 0) {
    queryParams.append("teamIds", payload.teamIds.join(","));
  } else if (typeof payload.teamIds === "string") {
    queryParams.append("teamIds", payload.teamIds);
  }

  if (payload.minRate) queryParams.append("minRate", payload.minRate);
  if (payload.maxRate) queryParams.append("maxRate", payload.maxRate);

  if (payload.minRequests || payload.minRequests === 0)
    queryParams.append("minRequests", payload.minRequests);
  if (payload.maxRequests || payload.maxRequests === 0)
    queryParams.append("maxRequests", payload.maxRequests);

  if (payload.paymentType) queryParams.append("paymentType", payload.paymentType);

  if (payload.startDate) queryParams.append("startDate", payload.startDate);
  if (payload.endDate) queryParams.append("endDate", payload.endDate);
  if (payload.createStartDate) queryParams.append("createStartDate", payload.createStartDate);
  if (payload.createEndDate) queryParams.append("createEndDate", payload.createEndDate);
  if (payload.country) queryParams.append("country", payload.country);
  if (payload.city) queryParams.append("city", payload.city);
  if (payload.providerId) queryParams.append("providerId", payload.providerId);
  if (payload.teamId) queryParams.append("teamId", payload.teamId);
  if (payload.clientId) queryParams.append("clientId", payload.clientId);
  if (payload.projectId) queryParams.append("projectId", payload.projectId);
  if (payload.currency) queryParams.append("currency", payload.currency);
  if (payload.engineerCurrency) queryParams.append("engineerCurrency", payload.engineerCurrency);
  if (payload.createdById) queryParams.append("createdById", payload.createdById);
  if (payload.id) queryParams.append("id", payload.id);
  if (payload.canceledBy) queryParams.append("canceledBy", payload.canceledBy);
  if (payload.cancellationReason) queryParams.append("cancellationReason", payload.cancellationReason);
  // The columns the list is showing; the backend returns data for these alone.
  if (payload.columns?.length)
    queryParams.append("columns", [].concat(payload.columns).join(","));
  const response = await axios.get(`workOrders/customer?${queryParams.toString()}`);
  return response.data;
};

export const fetchWorkOrderCountries = async () => {
  const response = await axios.get("/workOrders/countries");
  return response.data.data;
};
export const fetchWorkOrderStatusCounts = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.search?.trim()) queryParams.append("search", payload.search.trim());
  if (payload.categoryId) queryParams.append("categoryId", payload.categoryId);
  if (payload.vendorId) queryParams.append("vendorId", payload.vendorId);
  if (payload.role) queryParams.append("role", payload.role);
  if (Array.isArray(payload.subCategoryIds) && payload.subCategoryIds.length > 0) {
    queryParams.append("subCategoryIds", payload.subCategoryIds.join(","));
  } else if (typeof payload.subCategoryIds === "string") {
    queryParams.append("subCategoryIds", payload.subCategoryIds);
  }
  if (Array.isArray(payload.clientIds) && payload.clientIds.length > 0) {
    queryParams.append("clientIds", payload.clientIds.join(","));
  } else if (typeof payload.clientIds === "string") {
    queryParams.append("clientIds", payload.clientIds);
  }
  if (Array.isArray(payload.teamIds) && payload.teamIds.length > 0) {
    queryParams.append("teamIds", payload.teamIds.join(","));
  } else if (typeof payload.teamIds === "string") {
    queryParams.append("teamIds", payload.teamIds);
  }

  if (payload.minRate) queryParams.append("minRate", payload.minRate);
  if (payload.maxRate) queryParams.append("maxRate", payload.maxRate);

  if (payload.minRequests || payload.minRequests === 0)
    queryParams.append("minRequests", payload.minRequests);
  if (payload.maxRequests || payload.maxRequests === 0)
    queryParams.append("maxRequests", payload.maxRequests);

  if (payload.paymentType) queryParams.append("paymentType", payload.paymentType);

  if (payload.startDate) queryParams.append("startDate", payload.startDate);
  if (payload.endDate) queryParams.append("endDate", payload.endDate);
  if (payload.createStartDate) queryParams.append("createStartDate", payload.createStartDate);
  if (payload.createEndDate) queryParams.append("createEndDate", payload.createEndDate);
  if (payload.country) queryParams.append("country", payload.country);
  if (payload.city) queryParams.append("city", payload.city);
  if (payload.providerId) queryParams.append("providerId", payload.providerId);
  if (payload.clientId) queryParams.append("clientId", payload.clientId);
  if (payload.projectId) queryParams.append("projectId", payload.projectId);
  if (payload.teamId) queryParams.append("teamId", payload.teamId);
  if (payload.currency) queryParams.append("currency", payload.currency);
  if (payload.engineerCurrency) queryParams.append("engineerCurrency", payload.engineerCurrency);

  if (payload.createdById) queryParams.append("createdById", payload.createdById);
  if (payload.id) queryParams.append("id", payload.id);
  if (payload.canceledBy) queryParams.append("canceledBy", payload.canceledBy);
  if (payload.cancellationReason) queryParams.append("cancellationReason", payload.cancellationReason);

  if (Array.isArray(payload.status)) {
    payload.status.forEach((s) => s && queryParams.append("status", s));
  } else if (payload.status) {
    queryParams.append("status", payload.status);
  }

  const response = await axios.get(`workOrders/statusCounts?${queryParams.toString()}`);
  return response.data;
};

export const fetchUserWorkOrdersDocuments = async () => {
  const response = await axios.get(`workOrders/documents`);
  return response.data;
};

export function findJobs(payload) {
  const queryParams = new URLSearchParams();

  if (payload.latitude) queryParams.append("latitude", payload.latitude);
  if (payload.longitude) queryParams.append("longitude", payload.longitude);
  if (payload.radius) queryParams.append("radius", payload.radius);
  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);
  if (payload.search?.trim()) queryParams.append("search", payload.search.trim());
  if (payload.startDate) queryParams.append("startDate", payload.startDate);
  if (payload.endDate) queryParams.append("endDate", payload.endDate);
  if (payload.createStartDate) queryParams.append("createStartDate", payload.createStartDate);
  if (payload.createEndDate) queryParams.append("createEndDate", payload.createEndDate);
  if (payload.minRate) queryParams.append("minRate", payload.minRate);
  if (payload.maxRate) queryParams.append("maxRate", payload.maxRate);
  if (payload.minRequests || payload.minRequests === 0)
    queryParams.append("minRequests", payload.minRequests);
  if (payload.maxRequests || payload.maxRequests === 0)
    queryParams.append("maxRequests", payload.maxRequests);
  if (payload.categoryId) queryParams.append("categoryId", payload.categoryId);
  if (payload.vendorId) queryParams.append("vendorId", payload.vendorId);
  if (payload.paymentType) queryParams.append("paymentType", payload.paymentType);
  if (Array.isArray(payload.subCategoryIds) && payload.subCategoryIds.length > 0) {
    queryParams.append("subCategoryIds", payload.subCategoryIds.join(","));
  }
  if (payload.isCoverageApplied) queryParams.append("isCoverageApplied", "true");

  return axios.get("workOrders/findJobs", { params: queryParams }).then((res) => res.data);
}

export function fetchJobDetail(id) {
  return axios.get(`workOrders/${id}`).then((res) => res.data);
}

export function fetchJobDetailsByReferenceId(id) {
  return axios.get(`workOrders/${id}?referenceId=true`).then((res) => res.data);
}

export function fetchFreelancerJobs(payload) {
  return axios.post(`workOrders/engineer`, payload).then((res) => res.data);
}

export function fetchJobsCount(payload) {
  const queryParams = new URLSearchParams();
  if (payload.search?.trim()) queryParams.append("search", payload.search.trim());
  if (payload.latitude) queryParams.append("latitude", payload.latitude);
  if (payload.longitude) queryParams.append("longitude", payload.longitude);
  if (payload.radius) queryParams.append("radius", payload.radius);
  if (payload.categoryId) queryParams.append("categoryId", payload.categoryId);
  if (payload.vendorId) queryParams.append("vendorId", payload.vendorId);
  if (payload.subCategoryIds?.length > 0) {
    queryParams.append("subCategoryIds", payload.subCategoryIds.join(","));
  }
  if (payload.minRate) queryParams.append("minRate", payload.minRate);
  if (payload.maxRate) queryParams.append("maxRate", payload.maxRate);
  if (payload.minRequests || payload.minRequests === 0)
    queryParams.append("minRequests", payload.minRequests);
  if (payload.maxRequests || payload.maxRequests === 0)
    queryParams.append("maxRequests", payload.maxRequests);
  if (payload.paymentType) queryParams.append("paymentType", payload.paymentType);
  if (payload.startDate) queryParams.append("startDate", payload.startDate);
  if (payload.endDate) queryParams.append("endDate", payload.endDate);
  if (payload.createStartDate) queryParams.append("createStartDate", payload.createStartDate);
  if (payload.createEndDate) queryParams.append("createEndDate", payload.createEndDate);
  if (payload.isCoverageApplied) queryParams.append("isCoverageApplied", "true");

  return axios.get(`workOrders/jobsCount`, { params: queryParams }).then((res) => res.data);
}
export const fetchMaxRate = async (paymentType) => {
  const response = await axios.get(`workOrders/maxRate`, {
    params: { paymentType },
  });
  return response.data;
};
export const fetchMaxOffersCount = async () => {
  const response = await axios.get(`workOrders/maxOffersCount`);
  return response.data;
};
export function addWorkOrderNote(payload) {
  return axios.patch(`workOrders/${payload.workOrderId}/addNote`, payload).then((res) => res.data);
}

export function updateWorkOrderApi(payload) {
  return axios.patch(`workOrders/${payload.id}`, payload).then((res) => res.data);
}
export function updateWorkOrderEngineerPayment(payload) {
  return axios.patch(`workOrders/${payload.id}/engineerPayment`, payload).then((res) => res.data);
}

export function updateWorkOrderCompanyExpenses(payload) {
  return axios.patch(`workOrders/${payload.id}/companyExpenses`, payload).then((res) => res.data);
}

export function republishWorkOrderApi(workOrderId) {
  return axios.get(`workOrders/republish/${workOrderId}`).then((res) => res.data);
}

export function updateWorkOrderTimeLog(payload) {
  const { workOrderId, type, ...rest } = payload;

  return axios
    .patch(`workOrders/timeLog/${workOrderId}?type=${type}`, { ...rest })
    .then((res) => res.data);
}

export function updateWorkOrderSubStatus(payload) {
  return axios.patch(`workOrders/${payload.id}/subStatus`, payload).then((res) => res.data);
}

export function updateWorkOrderStatus(payload) {
  return axios.patch(`workOrders/${payload.id}/status`, payload).then((res) => res.data);
}

export function publishDraftedWorkOrder(id) {
  return axios.post(`workOrders/publish/${id}`).then((res) => res.data);
}

export function markWorkOrderComplete(id) {
  return axios.get(`workOrders/${id}/complete`).then((res) => res.data);
}

export function markWorkOrderInComplete(payload) {
  return axios.post(`workOrders/incomplete`, payload).then((res) => res.data);
}
export function reviewWorkOrder(id) {
  return axios.post(`workOrders/${id}/review`).then((res) => res.data);
}

export function verifyWorkOrder(id) {
  return axios.post(`workOrders/${id}/verify`).then((res) => res.data);
}

export function approveWorkOrder(id) {
  return axios.post(`workOrders/${id}/approve`).then((res) => res.data);
}

export function markWorkOrderAsPOPending(id) {
  return axios.post(`workOrders/${id}/poPending`).then((res) => res.data);
}

export function markWorkOrderAsPayable(id) {
  return axios.post(`workOrders/${id}/markPayable`).then((res) => res.data);
}

export function fetchWorkOrderPaymetDetails(id) {
  return axios.get(`workOrders/estimatedPayment/${id}`).then((res) => res.data);
}

export function draftWorkOrder(id) {
  return axios.patch(`workOrders/draft/${id}`).then((res) => res.data);
}

export function fetchProvidersCount(payload) {
  const queryParams = new URLSearchParams();

  // Include only non-empty filters in the query parameters
  if (payload.latitude) {
    queryParams.append("latitude", payload.latitude);
  }
  if (payload.longitude) {
    queryParams.append("longitude", payload.longitude);
  }
  if (payload.radius) {
    queryParams.append("radius", payload.radius);
  }
  if (payload.workOrderId) {
    queryParams.append("workOrderId", payload.workOrderId);
  }
  return axios.get(`workOrders/providersCount`, { params: queryParams }).then((res) => res.data);
}

export function fetchUserAllowedAction(id) {
  return axios.get(`workOrders/actions/allowed/${id}`).then((res) => res.data);
}

export function cancelWorkOrderByEngineer(payload) {
  return axios.post(`workOrders/engineer/cancel/${payload?.id}`, payload).then((res) => res.data);
}

export function cancelWorkOrderByClient(payload) {
  return axios.post(`workOrders/client/cancel/${payload?.id}`, payload).then((res) => res.data);
}

export function deleteWorkOrder(payload) {
  return axios.delete(`workOrders/${payload?.id}`, payload).then((res) => res.data);
}

export function uploadSignOffSheet(formData) {
  return axios
    .post("workOrders/signOffSheet", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
}

export function uploadDeliverableFiles(workOrderId, formData) {
  return axios
    .post(`workOrders/${workOrderId}/deliverables`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
}

export function deleteDeliverableFile(assetId) {
  return axios.delete(`workOrders/deliverables/${assetId}`).then((res) => res.data);
}
export function downloadWorkOrderFiles(workOrderId) {
  return axios
    .get(`workOrders/download/deliverables/${workOrderId}`, {
      responseType: "blob",
    })
    .then((res) => res.data);
}
export function downloadTimeSheet(workOrderId) {
  return axios
    .get(`workOrders/download/timesheet/${workOrderId}`, {
      responseType: "blob",
    })
    .then((res) => res.data);
}

export function undoApproval(workOrderId) {
  return axios.patch(`workOrders/revert/${workOrderId}`).then((res) => res.data);
}

export function createWorkOrderLog(payload) {
  return axios.post(`workOrderLogs`, payload).then((res) => res.data);
}
export function getWorkOrderLogsById(workOrderId, params = {}) {
  return axios
    .get(`workOrderLogs/workOrder/${workOrderId}`, {
      params: {
        page: params.page,
        limit: params.limit,
      },
    })
    .then((res) => res.data);
}
export function getLogDetailsByLogId(logId) {
  return axios.get(`workOrderLogs/${logId}`).then((res) => res.data);
}
